import React from 'react';
import { App } from 'reactifi';
import PropTypes from 'prop-types';
import RegistrationContainer from './containers/RegistrationContainer';
import createStore from './store/registrationStore';

const index = (props, _railsContext) => {
  return (
    <App createStore={() => createStore(props || {})}>
      <RegistrationContainer
        {..._railsContext}
        {...props}
        organizationId={props.organization.id}
        currentUserId={props.user.id}
        notifiUrl={props.notifi_url}
        path="/"
      />
    </App>
  );
};

index.propTypes = {
  notifi_url: PropTypes.string,
  organization: PropTypes.object,
  user: PropTypes.object
};

export default index;
